var getPageData = function (data, pageNumber, pageSize) {
    var start = pageNumber > 0 ? (pageNumber - 1) * pageSize : 0;
    return data.slice(start, start + pageSize);
};
export var getNumberOfPages = function (numItems, pageSize) {
    return Math.max(1, Math.floor(numItems / pageSize) + Math.sign(numItems % pageSize));
};
var getLastPageNumber = function (data, pageSize) { return getNumberOfPages(data.length, pageSize); };
export var getPage = function (data, pageNumber, pageSize) {
    if (data === null || data === void 0 ? void 0 : data.length) {
        var result = getPageData(data, pageNumber, pageSize);
        if (result.length > 0) {
            return { data: result, pageNumber: pageNumber };
        }
        var pn = getLastPageNumber(data, pageSize);
        return {
            data: getPageData(data, pn, pageSize),
            pageNumber: pn,
        };
    }
};
//# sourceMappingURL=pagination.js.map